import { type QueryOptions, type UseQueryResult, useQuery } from '@tanstack/react-query';
import axios from 'axios';

import { ADMIN_SETTINGS } from '../config/apiPaths';
import { DEFAULT_SCHOOL_SETTINGS } from '../config/settingsConfig';
import { type GetAdminSettings, type SchoolSettings } from '../types/apiTypes';
import { getUrls } from '../utils/url';

export const useAdminSettings = (props?: QueryOptions): UseQueryResult<SchoolSettings> => {
    const { api } = getUrls();

    return useQuery({
        queryKey: [ADMIN_SETTINGS],
        initialData: DEFAULT_SCHOOL_SETTINGS,
        queryFn: async () => {
            const response = await axios.get<GetAdminSettings>(`${api}${ADMIN_SETTINGS}`);
            return response.data.data;
        },
        ...props
    });
};
